// extracted by css-extract-rspack-plugin
export default {"menu":"ProductsMenu-module__menu","mark":"ProductsMenu-module__mark"};